import { LandingPageContent } from '../types';
import giftsForKids from './giftsForKids';
import personalizedGiftsForKids from './personalizedGiftsForKids';
import personalizedStoryBooks from './personalizedStoryBooks';
import personalizedColoringBooks from './personalizedColoringBooks';
import birthdayGiftsForKids from './birthdayGiftsForKids';
import christmasGiftsForKids from './christmasGiftsForKids';
import christeningGifts from './christeningGifts';
import eidGiftsForKids from './eidGiftsForKids';
import giftsForThreeYearOlds from './giftsForThreeYearOlds';
import giftsForFourYearOlds from './giftsForFourYearOlds';
import giftsForFiveYearOlds from './giftsForFiveYearOlds';
import customKidsTShirts from './customKidsTShirts';
import greekBooksForKids from './greekBooksForKids';
import arabicBooksForKids from './arabicBooksForKids';
import prosopopiimenaPaidikaVivlia from './prosopopiimenaPaidikaVivlia';

/**
 * Every keyword-targeted landing page, in the order they should appear in the
 * sitemap. `scripts/prerender.js` reads this list (via the generated route
 * manifest) to decide what to snapshot to static HTML.
 */
export const LANDING_PAGES: LandingPageContent[] = [
	giftsForKids,
	personalizedGiftsForKids,
	personalizedStoryBooks,
	personalizedColoringBooks,
	birthdayGiftsForKids,
	christmasGiftsForKids,
	christeningGifts,
	eidGiftsForKids,
	giftsForThreeYearOlds,
	giftsForFourYearOlds,
	giftsForFiveYearOlds,
	customKidsTShirts,
	greekBooksForKids,
	arabicBooksForKids,
	prosopopiimenaPaidikaVivlia,
];

export const landingByPath = (path: string): LandingPageContent | undefined => {
	const clean = path.replace(/\/+$/, '') || '/';
	return LANDING_PAGES.find((p) => p.path === clean);
};

export default LANDING_PAGES;
